import React, { useRef, useEffect } from 'react';
import { Typo, useOnScreen } from 'tmt-ui-kit';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { actions as galleryActions } from '~/redux/reducers/gallery';

import { path } from '~/utils/media';
import { GalleryName } from '~/utils/gallery';

const GalleryContainer = styled.div`
  display: flex;
  margin-left: 32px;
  /* ${props => (!props.restaurant ? 'margin-left: 8px;' : 'margin-left: 32px;')} */
  flex-wrap: wrap;
  @media screen and (max-width: 700px) {
    margin: auto;
  }
  @media screen and (max-width: 415px) {
    width: 100%;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-content: space-between;
  flex-basis: 32%;
`;

const BlackOpacity = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
`;

const MoreCountText = styled(Typo.Medium)`
  font-size: 22px !important;
  color: ${props => props.theme.white} !important;
`;

const Image = styled.img`
  cursor: pointer;
  display: block;
  object-fit: cover;
  border-radius: 6px;
  width: 100%;
  height: 224px;
  background-color: ${props => props.theme.blueGrayLighter};
  border-color: transparent;
  outline: none;
  cursor: pointer;
`;

const SquareImage = styled(Image)`
  height: 100px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  width: 100%;
`;

const enhance = connect(
  null,
  {
    openAndGoTo: galleryActions.openAndGoTo,
  }
);

const MiniGallery = (props) => {
  const imageRefs = useRef([]);
  const containerRef = useRef(null);
  const isSeen = useOnScreen(containerRef);
  useEffect(() => {
    if (isSeen) {
      imageRefs.current.forEach(imageRef => {
        const imageDom = imageRef;
        imageDom.src = imageDom.dataset.src;
        imageDom.srcset = imageDom.dataset.srcset;
      });
    }
  }, [isSeen]);
  const { images, defaultAlt } = props;
  const secondRowImages = images.slice(1, 4);
  return (
    <GalleryContainer ref={containerRef}>
      <Image
        onClick={() => props.openAndGoTo(0, GalleryName.LOCAL_TABLE, { images, defaultAlt })}
        ref={c => { imageRefs.current[0] = c; }}
        src=""
        data-src={path(images[0].image, 'imagesThumbnail')}
        data-srcset={`${path(images[0].image, 'imagesThumbnail2x')} 2x`}
        alt={images[0].caption}
      />
      {secondRowImages.length > 0 && (
        <Row>
          {secondRowImages.map((image, idx) => (
            <ImageContainer
              onClick={() => props.openAndGoTo(idx + 1, GalleryName.LOCAL_TABLE, { images, defaultAlt })}
            >
              <SquareImage
                key={idx}
                ref={c => { imageRefs.current[idx + 1] = c; }}
                src=""
                data-src={path(image.image, 'imagesThumbnail')}
                data-srcset={`${path(image.image, 'imagesThumbnail2x')} 2x`}
                alt={image.caption}
              />
              {images.length > 4 && idx === 2 && (
                <BlackOpacity>
                  <MoreCountText>
                    +{images.length - 4}
                  </MoreCountText>
                </BlackOpacity>
              )}
            </ImageContainer>
          ))}
        </Row>
      )}
    </GalleryContainer>
  );
};

MiniGallery.propTypes = {
  images: PropTypes.array.isRequired,
  defaultAlt: PropTypes.string,
  openAndGoTo: PropTypes.func
};

export default enhance(MiniGallery);
